import { Commit, StoreOptions } from 'vuex';
import smh, { SMH } from '@/renderer/scripts/smh';

export enum EventMap {
  GET_REMOTE_CONFIG = 'GET_REMOTE_CONFIG',
  SET_ENABLE_PREVIEW = 'SET_ENABLE_PREVIEW',
  SET_ENABLE_EDIT = 'SET_ENABLE_EDIT',
  SET_EDIT_DOC_TYPES = 'SET_EDIT_DOC_TYPES',
  SET_ENABLE_MEDIAPROCESSING = 'SET_ENABLE_MEDIAPROCESSING',
}

export interface RemoteConfigData {
  enableDocPreview: boolean;
  enableDocEdit: boolean;
  enableDocEditTypes: string[];
  enableMediaProcessing: boolean;
}

interface ActionParam {
  commit: Commit;
  state: RemoteConfigData;
}

/**
 * @description 默认数据处理格式
 * @export
 * @enum {number}
 */
const defaultEditDocTypes =
  'doc|dot|wps|wpt|docx|dotx|docm|dotm|txt|xls|xlt|et|xlsx|xltx|xlsm|xltm|ppt|pptx|pptm|ppsx|ppsm|pps|potx|potm|dpt|dps';

const defaultState = {
  enableDocPreview: true,
  enableDocEdit: true,
  enableDocEditTypes: defaultEditDocTypes.split('|'),
  enableMediaProcessing: true,
};

const remoteConfig: StoreOptions<RemoteConfigData> = {
  state: defaultState,
  getters: {
    enableDocPreview: (state: RemoteConfigData) => state.enableDocPreview, // 是否开启文档预览
    enableDocEdit: (state: RemoteConfigData) => state.enableDocEdit, // 是否开启文档编辑
    enableDocEditTypes: (state: RemoteConfigData) => state.enableDocEditTypes, // 当前编辑文档允许的格式
    enableMediaProcessing: (state: RemoteConfigData) => state.enableMediaProcessing, // 是否开启万象媒体水印
  },
  mutations: {
    [EventMap.SET_ENABLE_PREVIEW](state: RemoteConfigData, val: boolean) {
      state.enableDocPreview = val;
    },
    [EventMap.SET_ENABLE_EDIT](state: RemoteConfigData, val: boolean) {
      state.enableDocEdit = val;
    },
    [EventMap.SET_EDIT_DOC_TYPES](state: RemoteConfigData, val: string[]) {
      state.enableDocEditTypes = val;
    },
    [EventMap.SET_ENABLE_MEDIAPROCESSING](state: RemoteConfigData, val: boolean) {
      state.enableMediaProcessing = val;
    },
  },
  actions: {
    async [EventMap.GET_REMOTE_CONFIG]({ commit, state }: ActionParam) {
      try {
        const { data } = await smh.api.getRemoteConfig();
        const newState = {
          enableDocPreview: data.enableDocPreview ?? defaultState.enableDocPreview,
          enableDocEdit: data.enableDocEdit ?? defaultState.enableDocEdit,
          enableDocEditTypes: data.enableDocEditTypes ?? defaultState.enableDocEditTypes,
          enableMediaProcessing: data.enableMediaProcessing ?? defaultState.enableMediaProcessing,
        };
        commit(EventMap.SET_ENABLE_PREVIEW, newState.enableDocPreview);
        commit(EventMap.SET_ENABLE_EDIT, newState.enableDocEdit);
        commit(
          EventMap.SET_EDIT_DOC_TYPES,
          newState.enableDocEditTypes.map((v: string) => v.replace('.', '')),
        );
        commit(EventMap.SET_ENABLE_MEDIAPROCESSING, newState.enableMediaProcessing);
        return data;
      } catch (error) {
        commit(EventMap.SET_ENABLE_PREVIEW, defaultState.enableDocPreview);
        commit(EventMap.SET_ENABLE_EDIT, defaultState.enableDocEdit);
        commit(EventMap.SET_EDIT_DOC_TYPES, defaultState.enableDocEditTypes);
        commit(EventMap.SET_ENABLE_MEDIAPROCESSING, defaultState.enableMediaProcessing);
        return [];
      }
    },
  },
};

export default remoteConfig;
